import { get } from "lodash-es";
import { MESApiService, getMomentTz, spParameter } from "../../../services";
import type { Section, SectionFamily, TopSection } from "../models/Section";

const moment = getMomentTz();

export const getSectionFamilies = async ({
	schema,
	signal,
}: {
	schema?: string;
	signal?: AbortSignal;
}): Promise<SectionFamily[]> => {
	const apiService = new MESApiService();

	const resp = await apiService.callV2(
		`[${schema}].[GetSectionFamilies]`,
		[],
		signal,
	);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as SectionFamily[];
	} else {
		throw new Error(resp.message || "Error fetching section families");
	}
};

export const getSections = async ({
	schema,
	sectionFamilyId,
	searchText,
	signal,
}: {
	schema?: string;
	sectionFamilyId?: number | null;
	searchText?: string | null;
	signal?: AbortSignal;
}): Promise<Section[]> => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [];

	if (sectionFamilyId) {
		parameters.push({ name: "SectionFamilyId", value: sectionFamilyId });
	}

	if (searchText) {
		parameters.push({ name: "SearchText", value: searchText });
	}

	const resp = await apiService.callV2(
		`[${schema}].[GetSections]`,
		parameters,
		signal,
	);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as Section[];
	} else {
		throw new Error(resp.message || "Error fetching sections");
	}
};

export const getTopUsedSections = async ({
	schema,
	top = 5,
	signal,
}: {
	schema?: string;
	top?: number;
	signal?: AbortSignal;
}): Promise<TopSection[]> => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [{ name: "Top", value: top }];

	const resp = await apiService.callV2(
		`[${schema}].[GetTopUsedSections]`,
		parameters,
		signal,
	);

	if (resp.ok) {
		let rows = get(resp, "data.tables[0].rows", []) as TopSection[];

		rows = rows.map((section) => ({
			...section,
			LastUsedTimestamp: section.LastUsedTimestamp
				? moment.utc(section.LastUsedTimestamp).toDate()
				: null,
		}));

		return rows;
	} else {
		throw new Error(resp.message || "Error fetching top used sections");
	}
};
